import { render, staticRenderFns } from "./communityInspectionTree.vue?vue&type=template&id=01106672&scoped=true"
import script from "./communityInspectionTree.vue?vue&type=script&lang=js"
export * from "./communityInspectionTree.vue?vue&type=script&lang=js"
import style0 from "./communityInspectionTree.vue?vue&type=style&index=0&id=01106672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01106672",
  null
  
)

export default component.exports